import React, { useEffect, useRef, forwardRef, useImperativeHandle } from 'react';

const TurnstileWidget = forwardRef(({ onVerify }, ref) => {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);
  const onVerifyRef = useRef(onVerify);
  onVerifyRef.current = onVerify;

  useImperativeHandle(ref, () => ({
    refresh() {
      onVerifyRef.current('');
      if (window.turnstile && widgetIdRef.current !== null) {
        window.turnstile.reset(widgetIdRef.current);
      }
    },
  }), []);

  useEffect(() => {
    let disposed = false;
    const clearToken = () => {
      if (!disposed) onVerifyRef.current('');
    };
    const renderTurnstile = () => {
      if (disposed || !window.turnstile || !containerRef.current || widgetIdRef.current !== null) return;
      widgetIdRef.current = window.turnstile.render(containerRef.current, {
        sitekey: process.env.REACT_APP_TURNSTILE_SITE_KEY,
        callback: (token) => {
          if (!disposed) onVerifyRef.current(token);
        },
        'expired-callback': clearToken,
        'error-callback': clearToken,
      });
    };

    let script = document.getElementById('cf-turnstile-script');
    if (!script) {
      script = document.createElement('script');
      script.id = 'cf-turnstile-script';
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      document.body.appendChild(script);
    }
    // A remounted widget can encounter a script that is still loading.
    script.addEventListener('load', renderTurnstile);
    script.addEventListener('error', clearToken);
    renderTurnstile();

    return () => {
      disposed = true;
      script.removeEventListener('load', renderTurnstile);
      script.removeEventListener('error', clearToken);
      if (window.turnstile && widgetIdRef.current !== null) {
        window.turnstile.remove(widgetIdRef.current);
      }
      widgetIdRef.current = null;
    };
  }, []);

  return <div id="turnstile-widget" ref={containerRef} style={{ marginTop: '20px' }} />;
});

export default TurnstileWidget;
